/**
 * Created by Denis Kuzin on 12 october 2022
 */

const Pixel = function (options) {
    this.type = options.type;
    this.order = options.order;
    this.amountPixels = options.amountPixels;
    this.onDiePixel = options.onDiePixel;
    this.collectPrize = options.collectPrize || function () {};
    this.reward = PixelsSwarmConfig[this.type].reward;
    this.friendRequest = options.friendRequest;

    this.flying = false;
    this.dead = false;

    this.onFlyingChanged = function () {};
    this.onStartTutorial = function () {};
    this.onAnimateCollect = function () {};
    this.onDie = function () {};

    if (options.spawnPoint) {
        this.x = options.spawnPoint.x;
        this.y = options.spawnPoint.y;
    } else {
        const centerCell = Map2d.currentMap.getScreenCenterCell() || Map2d.currentMap.getFocusCell();
        let startingY = 0;

        for (let y = startingY; y < centerCell.y; y++) {
            if (Map2d.currentMap.isScreenCellPosition(centerCell.x, y)) {
                break;
            }

            startingY = y;
        }

        const dy = 4;
        this.x = centerCell.x + Math.ceil(this.order - this.amountPixels / 2);
        this.y = (startingY - dy - 2) + PseudoRandom.GET().random(dy);
    }
};

Pixel.prototype.setView = function (view) {
    this.view = view;
};

Pixel.prototype.startTutorial = function (callback) {
    this.onStartTutorial(callback);
};

Pixel.prototype.getView = function () {
    return this.view;
};

Pixel.prototype.setFlying = function (flying) {
    if (flying !== this.flying) {
        this.flying = flying;
        this.onFlyingChanged(this.flying);
    }
};

Pixel.prototype.collect = function () {
    if (this.dead) {
        return;
    }

    this.onAnimateCollect((options) => {
        if (this.reward.resource) {
            cleverapps.effects.fire(options.effect);

            Map2dLocation.currentLocation.addReward(
                this.reward.resource === "coins" ? "soft" : this.reward.resource,
                PseudoRandom.GET().random(this.reward.amount[0], this.reward.amount[1]),
                options.source,
                {
                    delay: options.delay,
                    deltaSource: options.source
                }
            );
        } else {
            let prize = Prizes.Generate(this.reward)[0];

            if (!prize) {
                prize = {
                    code: PseudoRandom.GET().choose(cleverapps.unitsLibrary.listAvailableByType("fruit")),
                    stage: 0
                };
            }

            const left = Map2dLocation.currentLocation.spawn(prize, options.source, {
                fromNode: true,
                effect: options.effect,
                delay: options.delay,
                spawnSource: "pixel"
            });
            if (left.length) {
                return;
            }
        }

        if (this.friendRequest) {
            this.friendRequest.process();
        }

        this.collectPrize();
        this.die();

        cleverapps.tutorial.trigger("pixel_collected", this.type);
    });
};

Pixel.prototype.die = function (silent) {
    this.dead = true;

    this.setFlying(false);
    this.onDiePixel(this);

    this.onDie(silent);
};
